var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.695652 0C0.511154 0 0.334212 0.0732917 0.203752 0.203752C0.0732917 0.334212 0 0.511154 0 0.695652V15.3043C0 15.4888 0.0732917 15.6658 0.203752 15.7962C0.334212 15.9267 0.511154 16 0.695652 16C0.880151 16 1.05709 15.9267 1.18755 15.7962C1.31801 15.6658 1.3913 15.4888 1.3913 15.3043V0.695652C1.3913 0.511154 1.31801 0.334212 1.18755 0.203752C1.05709 0.0732917 0.880151 0 0.695652 0Z",
    fill: "#FF7452"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0618 4.43113C11.2079 2.14939 9.29137 2.30243 7.59746 2.43461C5.98702 2.5633 4.71398 2.66417 3.32268 0.94939C3.23182 0.837963 3.10866 0.757425 2.97016 0.718857C2.83165 0.680288 2.68459 0.685582 2.54922 0.734012C2.41384 0.782442 2.2968 0.871627 2.21419 0.989301C2.13158 1.10697 2.08746 1.24735 2.08789 1.39113V7.30417C2.08766 7.42239 2.11755 7.53873 2.17476 7.64219C2.23197 7.74565 2.3146 7.83282 2.41485 7.89548C2.92367 8.22497 3.51649 8.40125 4.12268 8.4033C5.51398 8.4033 6.83572 7.492 8.04615 6.66417C9.83398 5.43635 10.9992 4.74417 12.154 5.46417C12.2948 5.56202 12.4667 5.60444 12.6369 5.58329C12.807 5.56214 12.9633 5.4789 13.0758 5.34955C13.1884 5.22021 13.2492 5.05386 13.2466 4.88244C13.244 4.71101 13.1782 4.54658 13.0618 4.42069V4.43113Z",
    fill: "#FF7452"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPriority);
export default __webpack_public_path__ + "static/media/highPriority.7d419e742ab9ed7e4a7ab109d208d200.svg";
export { ForwardRef as ReactComponent };